import Hosts from '../components/templates';

export const HostsContainer = () => {
  return <Hosts />;
};
